'use client';

import { Skeleton } from '@mui/material';
import { HousingCardSkeleton } from '@/components';
import { Container, Wrapper } from '@/features/pages/home';
import { BgFigure } from '@/features/pages/home/components/Discounted/styled';
import discountBgFigure from '@/assets/webp/discounted-bg-form.webp';
import { GridList, SimilarHead } from './styled';

export const SimilarObjectsSkeleton = () => (
  <Wrapper $bgColor="blue">
    <Container>
      <SimilarHead>
        <Skeleton
          variant="text"
          width={300}
          height={40}
          sx={{ bgcolor: 'rgba(255,255,255,0.15)' }}
        />
      </SimilarHead>
      <GridList>
        {Array.from({ length: 3 }).map((_, i) => (
          <HousingCardSkeleton key={i} />
        ))}
      </GridList>
    </Container>
    <BgFigure>
      <img src={discountBgFigure.src} alt="background-decoration" />
    </BgFigure>
  </Wrapper>
);
